<template>
  <div
    class="px-8 py-6 d-flex flex-column justify-space-between"
    style="height:100%; width:100%;"
  >
    <div>
      <h3>
        신규 발주 승인 - 승인/수정 히스토리
      </h3>
      <div class="d-flex pb-5 pt-5 align-center">
        <div class="pr-5">
          <v-select
            v-resize="updateWindowHeight"
            class=" width160-height30 border-5c5c5c"
            height="28"
            :items="searchDateList"
            solo
            flat
            dense
            v-model="searchDateCategory"
            label="기간선택"
          />
        </div>
        <input
          readonly
          v-model="startDate"
          @click="startDateOpenMethod()"
          class="cursor-pointer border-b8b8b8 back-white color-6c6c6c width170-height36 rounded-md"
        />
        <span class="pr-4 pl-5">~</span>
        <input
          readonly
          v-model="finishDate"
          @click="finishDateOpenMethod()"
          class="cursor-pointer border-b8b8b8 back-white color-6c6c6c width170-height36 mr-3 rounded-md"
        />
        <DatePicker
          @date="startDateMethod"
          :statement="'start'"
          :sendDialog="startDateOpen"
          @datefunction="startDateFunction()"
        />
        <DatePicker
          @date="finishDateMethod"
          :statement="'finish'"
          :sendDialog="finishDateOpen"
          @datefunction="finishDateFunction()"
        />
      </div>
      <div class="d-flex pb-5">
        <div class="pr-5">
          <v-select
            class="border-5c5c5c width160-height30"
            height="32"
            :items="searchCategoryList"
            solo
            flat
            dense
            v-model="searchCategory"
            label="검색항목 선택"
          />
        </div>
        <div class="pr-5">
          <input
            class="border-width "
            v-model="searchWord"
            @keydown.enter="searchList"
          />
        </div>
        <v-btn
          color="#3F557D"
          width="78"
          height="32"
          class="color-white ml-3"
          @click="searchList"
        >
          <span class="search-text"> 확인</span>
        </v-btn>

        <v-spacer></v-spacer>
      </div>
      <v-simple-table
        class="width-100"
        :height="windowInnerHeight - 48 - 275"
        fixed-header
        dense
      >
        <thead class="height-44">
          <th
            class="back-8ca9dd color-white border-right-white"
            v-for="item in header"
            :key="item"
          >
            {{ item }}
          </th>
        </thead>
        <tbody>
          <tr
            v-for="index in tbodyLength"
            :key="index"
            class="text-center"
            v-if="approalList.length > 0"
          >
            <td
              class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa"
            >
              {{ approalList[index - 1 + (constPage - 1) * 20].orderName }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa ">
              {{ approalList[index - 1 + (constPage - 1) * 20].partName }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{ approalList[index - 1 + (constPage - 1) * 20].memoType }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{
                approalList[index - 1 + (constPage - 1) * 20].orderRegDate
                  | moment("YY-MM-DD")
              }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{ approalList[index - 1 + (constPage - 1) * 20].userName }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{
                approalList[index - 1 + (constPage - 1) * 20].regDate
                  | moment("YY-MM-DD")
              }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              <v-btn
                width="70"
                class="ma-0 pa-0"
                text
                @click="
                  downFile(
                    approalList[index - 1 + (constPage - 1) * 20]
                      .orderHistoryId,
                    approalList[index - 1 + (constPage - 1) * 20].partName
                  )
                "
              >
                다운로드
              </v-btn>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa"
              style="width:220px;"
            >
              <v-btn
                text
                @click="
                  memoListClick(
                    approalList[index - 1 + (constPage - 1) * 20].orderId,
                    'orderInvoice'
                  )
                "
                width="70"
                class="ma-0 pa-0"
                >메모확인</v-btn
              >
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <Pagination
      :length="constPageLength"
      :totalVisible="5"
      color="#5A94ED"
      @update-pagination="handleUpdatePage"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker";
import DatePickerMixin from "@/mixin/DatePicker";
import Commonality from "@/mixin/Commonality";
import ApprovalApi from "@/api/ApprovalService";
import FileService from "@/api/FileService";
import fileDownload from "@/assets/js/file-download.js";
import Pagination from "@/components/Pagination.vue";

export default {
  mixins: [DatePickerMixin, Commonality],
  props: ["orderId"],
  components: {
    DatePicker,
    Pagination,
  },
  created() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    constructionId() {
      return this.$store.state.Const.constructionId.constructionId;
    },
    tbodyLength() {
      return this.constPage > this.constPageLength - 1
        ? this.approalList.length % 20 == 0
          ? 20
          : this.approalList.length % 20
        : 20;
    },
  },
  data: () => ({
    approalList: [],
    approalStoreList: [],
    searchDateList: ["기간선택", "발주일자", "승인일자"],
    searchCategoryList: ["검색항목 선택", "차수", "부위", "승인상태", "승인자"],
    searchDateCategory: "기간선택",
    searchCategory: "검색항목 선택",
    companyTotalList: [],
    searchWord: "",
    header: [
      "차수",
      "부위",
      "승인상태",
      "발주일자",
      "승인자",
      "승인일자",
      "다운로드",
      "메모",
    ],
    constPageLength: 0,
    constPage: 1,
    windowInnerHeight: 0,
  }),

  methods: {
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    async init() {
      let payload = { constructionId: this.constructionId };
      let res = await ApprovalApi.approvalTotalList(payload);
      this.approalStoreList = res.data.list;
      this.approalList = res.data.list;
      this.constPageLength = Math.ceil(this.approalList.length / 20);
      if (this.orderId) {
        this.searchCategory = "차수";
        this.searchWord = this.orderId;
        this.searchList();
        this.$bus.$emit("changeListGroup", "승인/히스토리");
      }
    },
    searchList() {
      let filterList = this.approalStoreList;
      if (this.searchCategory == "차수") {
        filterList = filterList.filter((approal) =>
          approal.orderId.toString().includes(this.searchWord)
        );
      } else if (this.searchCategory == "부위") {
        filterList = filterList.filter((approal) =>
          approal.partName.includes(this.searchWord)
        );
      } else if (this.searchCategory == "승인상태") {
        filterList = filterList.filter((approal) =>
          approal.memoType.includes(this.searchWord)
        );
      } else if (this.searchCategory == "승인자") {
        filterList = filterList.filter((approal) =>
          approal.userName.includes(this.searchWord)
        );
      }

      if (this.searchDateCategory == "발주일자") {
        if (this.startDate != "") {
          filterList = filterList.filter(
            (item) => item.orderRegDate >= this.startDate
          );
        }
        if (this.finishDate != "") {
          filterList = filterList.filter(
            (item) => item.orderRegDate <= this.finishDate
          );
        }
      } else if (this.searchDateCategory == "승인일자") {
        if (this.startDate != "") {
          filterList = filterList.filter(
            (item) => item.regDate >= this.startDate
          );
        }
        if (this.finishDate != "") {
          filterList = filterList.filter(
            (item) => item.regDate <= this.finishDate
          );
        }
      }
      this.constPageLength = Math.ceil(filterList.length / 20);
      this.constPage = 1;
      this.approalList = filterList;
    },

    //승인 히스토리 관련 파일 다운로드 개발
    async downFile(historyId, partName) {
      let { constructionName } = this.$store.getters.getConstructionId;
      try {
        let { data, headers, success } = await FileService.cadDownload({
          orderHistoryId: historyId,
        });
        if (data.size == 0) {
          this.$bus.$emit(
            "dialog",
            "업로드된 파일이 없습니다. 확인 후 시도해주세요."
          );
          return;
        }
        fileDownload(
          data,
          `${constructionName}_${partName}.${
            headers["content-disposition"].split(".")[1]
          }`
        );
      } catch (error) {
        console.log(error);
        this.$bus.$emit(
          "dialog",
          "서버에 문제가 발생했습니다. 잠시 후 시도해주세요.",
          false
        );
      }
    },
    async handleUpdatePage(page) {
      this.constPage = page;
    },
  },
};
</script>

<style scoped>
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.width120-height30 {
  width: 120px;
  height: 30px;
}

.height-44 {
  height: 44px;
}

.border-width {
  width: 300px;
  height: 30px;
  border: thin solid #5c5c5c;
}

.width160-height30 {
  width: 150px !important;
  height: 36px !important;
}
.rounded-md {
  border-radius: 5px;
}
.color-6c6c6c {
  color: #6c6c6c;
}
.border-b8b8b8 {
  border: 1px solid #b8b8b8;
}
.width170-height36 {
  width: 120px;
  height: 30px;
}
@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
</style>
